"use strict";
exports.__esModule = true;
exports.EnumEvent = void 0;
/**
 *
 */
var EnumEvent;
(function (EnumEvent) {
    EnumEvent["VALIDATED"] = "payments.validated";
})(EnumEvent = exports.EnumEvent || (exports.EnumEvent = {}));
